import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ChangeLevel from './changelevel'
import {
    Box, Grid, Card, ListItem,
    CardContent, Button, FormControlLabel, Switch, Avatar, Collapse, IconButton, InputAdornment, CircularProgress
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {
    useMediaQuery
} from '@material-ui/core';
import { Link } from "react-router-dom";
import { useTranslate, Title, useDataProvider } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { baseApiUrl } from '../dataProvider/sails';
import IconTitle from './iconTitle';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomPoperUser from './CustomPoperUser';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import edit from '../assets/icons/ic_content_management_light.png';
import CustomTextField from './CustomTextField'
import CustomSwitch from '../CustomizedUIs/GreenSwitch'
import Loading from '../common/loading-page';
import TextButton from '../CustomizedUIs/TextButton';

let cancel = [];
const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
    },
    iconButton: {
        padding: 10,
    },
    large: {
        width: theme.spacing(12),
        height: theme.spacing(12),
        backgroundColor: '#f3f7fa',
    },
    avatarIcon: {
        width: 40,
        height: 40,
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    display: {
        display: 'none',
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        },
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textForce: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    borderForce: {
        width: '25.5px',
        height: '10.5px',
        backgroundColor: '#b4b5bd',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TitleLevel: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderLevel: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
        textAlign: 'center'
    },
    textbtnLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingBottom: '20px'
    },
    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        "&:hover": {
            backgroundColor: '#65a9db'
        },
    },
    textBtnImage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: '8px',

    },
    textRequired: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.54)',
    },
    textRequiredStar: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#e1503a',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
}))
export const CreateUser = () => {
    const dataProvider = useDataProvider();
    const history = useHistory();
    const [error, setError] = useState();
    const [notPermission, setNotPermission] = useState(false);
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const [openDialog, setOpenDialog] = useState(false);
    const classes = useStyles();
    const [dataRole, setDataRole] = useState([]);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [openRole, setOpenRole] = useState(false);
    const [openLanguage, setOpenLanguage] = useState(false);
    const [role, setRole] = useState();
    const [language, setLanguage] = useState();
    const [image, setImage] = useState('/images/2cc06ec0-069a-454f-ae03-8ee3ac8123fd.png');
    const [isSend, setIsSend] = useState(false);
    const [message, setMessage] = useState("");
    const [openAlert, setOpenAlert] = useState(false);
    const [entities, setEntities] = useState([]);
    const [forceUser, setForceUser] = useState(false);
    const [mobileApp, setMobileApp] = useState(false);
    const [videoCall, setVideoCall] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [cluster, setCluster] = useState([]);
    const [countcluster, setCountCluster] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [expandAll, setExpandAll] = useState(false);
    const [defaultSystemLanguage, setDefaultSystemLanguage] = useState('');

    const [textValue, setTextValue] = React.useState({
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phoneNumber: '',
        organisation: '',
    });
    const [validate, setValidate] = React.useState({
        lastName: {
            isError: true,
            message: ''
        },
        number: {
            isError: true,
            message: ''
        },
        userName: {
            isError: true,
            message: ''
        },
        firstName: {
            isError: true,
            message: ''
        }, email: {
            isError: true,
            message: ''
        },
        password: {
            isError: true,
            message: ''
        },
        phoneNumber: {
            isError: true,
            message: ''
        },
        organisation: {
            isError: true,
            message: ''
        }
    });

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const validateFc = (prop, value) => {
        if (prop === 'userName') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: value.length > 50 ? {
                        isError: true, message: translate(`pos.user.error.usernamecharacter`)
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else if (prop === 'email') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) === true ? {
                        isError: false, message: ''
                    } : {
                            isError: true, message: translate('pos.auth.errorEmail')
                        }
                })

            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })

    }

    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    // const theme = useSelector((state) =>
    //     state.theme === 'dark' ? darkTheme : lightTheme
    // );


    const handleOpenDialog = () => {
        cancel = entities.map(item => ({
            ...item
        }));
        setOpenDialog(true)
    }

    // event select language
    const handleClickOpenLanguage = () => {
        setOpenLanguage(!openLanguage)
    }
    const onChangeLanguage = (value) => {
        setLanguage(value)
        // setLanguageId(language.id)
        // setLanguageCode(language.code)
        setOpenLanguage(false)
    }
    // event select role
    const handleClickOpenRole = () => {
        setOpenRole(!openRole)
    }
    const onChangeRole = (value) => {
        setRole(value)
        // setRoleId(role.id)
        setOpenRole(false)
    }
    const handleChooseImage = (e) => {
        const form = new FormData();
        form.append('avatar', e.target.files[0]);
        dataProvider('UPLOAD', 'user/upload', form).then(({ data }) => {
            setImage(data.fileName);
        }).catch(error => {
            console.log('handleChooseImage error:', error)
        });
    }
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleChange = (e) => {
        setForceUser(e.target.checked);
    };

    const handleChangeMobileAppSwitch = (e) => {
        setMobileApp(e.target.checked);
        if (e.target.checked === false)
            setVideoCall(false)
    };

    const handleChangeVideoCallSwitch = (e) => {
        if (mobileApp)
            setVideoCall(e.target.checked);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const handleShowCluster = () => {
        let clusterName = [];
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    if (cluster.checked) {
                        clusterName.push(cluster.name);
                    }
                })
            });
        });
        setCluster(clusterName);
        setCountCluster(clusterName.length);
    }



    const handleSubmitUser = () => {
        setLoading(true)
        const clusterIds = [];
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    if (cluster.checked) {
                        clusterIds.push(cluster.id);

                    }
                })
            });
        });

        dataProvider('CREATE', 'users', {
            data: {
                email: textValue.email,
                username: textValue.userName,
                organisation: textValue.organisation,
                password: textValue.password,
                firstName: textValue.firstName,
                lastName: textValue.lastName,
                role: role.id,
                language: language.id,
                phoneNumber: textValue.phoneNumber,
                avatarURL: image,
                levels: clusterIds,
                isLdap: true,
                forceChangePassword: forceUser,
                mobileApp: mobileApp,
                videoCall: videoCall,
            }
        }).then(({ data }) => {
            history.push({
                pathname: '/users',
                state: { openCreate: true, name: textValue.userName, }
            });

        }).catch(response => {
            // TODO: Should show error message
            if (response.message === 'permissionIncorect') {
                setNotPermission(true)
            }
            window.scrollTo(0, 0);
            setLoading(false)
            setIsSend(false);
            setOpenAlert(true)
            setMessage(translate(response.message));
        });
    };

    const getLanguage = (defaultLanguage) => {
        let language = defaultLanguage[0].value
        let code
        switch (language) {
            case 'English':
                code = 'US'
                break;
            case 'Swedish':
                code = 'SE'
                break;
        }
        dataProvider('GET_LIST', "language", {
            filter: {

            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setDataLanguage(data);
                setLanguage(data.find(value => value.code === code))
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }

    useEffect(() => {
        var request = []
        var defaultLanguage

        request.push(dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Default System Language'
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            setDefaultSystemLanguage(data)
            defaultLanguage = data
        })
        )
        Promise.all(request)
            .then(() => {
                setLoading(false)
                getLanguage(defaultLanguage)
            })
            .catch(() => {
                console.log('Error')
            })
        dataProvider('GET_LIST', "rolesList", {
            filter: {},
            pagination: {},
            sort: {},

        })
            .then(({ data }) => {
                setDataRole(data);
                setRole(data.find(value => value.name == 'Admin'))
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });

        dataProvider('GET_LIST', "clusters", {
            filter: {

            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        })
            .then(({ data }) => {
                setEntities(data);
            }).catch(error => {
                setError(error);
            })
    }, []);
    if (!dataRole || !role) return null
    if (!dataLanguage || !language) return null
    if (loading) return <Loading show={true} />;
    if (error) return null;
    if (!dataRole) return null;


    return (
        <Box width='100%' >
            <Title className={classes.TitleCreate} title={translate(`pos.user.title`)} />
            <Box width={!isDesktop ? '95%' : '80%'} m='auto'>

                <IconTitle
                    TitleBack={translate(`pos.user.back`)}
                    TitleName=''
                    pathName='/users'
                />
                <Box display='flex' width='100%' justifyContent='center'>
                    <Box my={2} style={{ width: '500px' }} >
                        <Typography className={classes.TitleCreate}>{translate(`pos.user.create`)}</Typography>
                        <Box mt={3}>
                            <Collapse in={openAlert}>
                                <Alert severity={isSend ? "success" : "error"}>{message}</Alert>
                            </Collapse>
                        </Box>
                        <Box mt={3}>
                            <CustomTextField
                                required
                                onBlur={() => {
                                    validateFc('userName', textValue.userName)
                                }}
                                id="filled-basic"
                                label={translate(`pos.user.username`)}
                                value={textValue.userName}
                                error={validate.userName.message != "" && validate.userName.isError}
                                helperText={validate.userName.message}
                                onChange={textOnChange('userName')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleUsesName`)}
                                        content={translate(`pos.user.ConstentUserName`)}
                                        icon={<b>?</b>}
                                    />
                                } />
                        </Box>
                        <Box mt={3}>
                            <CustomTextField
                                required
                                onBlur={() => {
                                    validateFc('password', textValue.password)
                                }}
                                id="filled-basic"
                                label={translate(`pos.user.password`)}
                                value={textValue.password}
                                error={validate.password.message != "" && validate.password.isError}
                                helperText={validate.password.message}
                                onChange={textOnChange('password')}
                                style={{ width: 500 }}
                                type={showPassword ? 'text' : 'password'}
                                endDom={
                                    <InputAdornment position="end">

                                        {
                                            textValue.password === "" ?
                                                <CustomPoper
                                                    open={openPoper}
                                                    anchorEl={anchorEl}
                                                    handleClick={handleClickOpenPoper}
                                                    handleClose={handleClosePoper}
                                                    title={translate(`pos.user.TitlePassword`)}
                                                    content={translate(`pos.user.ConstentPassword`)}
                                                    icon={<b>?</b>}
                                                /> :
                                                <IconButton
                                                    size='small'
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>


                                        }

                                    </InputAdornment>
                                } />
                        </Box>
                        <Box alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '260px', height: '36px', backgroundColor: '#ffffff' }} >
                            <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate(`pos.user.forceuser`).toUpperCase()}</Typography>
                            <FormControlLabel
                                control={<CustomSwitch size="small" onChange={handleChange} />}
                                labelPlacement="start"
                                variant="caption"
                                style={{ margin: 0 }}
                            />
                        </Box>
                        <Box alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '260px', height: '36px', backgroundColor: '#ffffff' }} >
                            <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate(`pos.user.mobileAppUser`)}</Typography>
                            <FormControlLabel
                                control={<CustomSwitch size="small" checked={mobileApp} onChange={handleChangeMobileAppSwitch} />}
                                labelPlacement="start"
                                variant="caption"
                                style={{ margin: 0 }}
                            />
                        </Box>
                        <Box alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '260px', height: '36px', backgroundColor: '#ffffff' }} >
                            <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate(`pos.user.enableVideoCall`)}</Typography>
                            <FormControlLabel
                                control={<CustomSwitch size="small" checked={videoCall} onChange={handleChangeVideoCallSwitch} />}
                                labelPlacement="start"
                                variant="caption"
                                style={{ margin: 0 }}
                            />
                        </Box>
                        <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: ' #e6e6eb' }} />

                        <CustomTextField
                            required
                            onBlur={() => {
                                validateFc('firstName', textValue.firstName)
                            }}
                            id="filled-basic"
                            label={translate(`pos.user.firstname`)}
                            value={textValue.firstName}
                            error={validate.firstName.message !== "" && validate.firstName.isError}
                            helperText={validate.firstName.message}
                            onChange={textOnChange('firstName')}
                            style={{ width: 500 }}
                            endDom={
                                <CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.user.TitleFirstName`)}
                                    content={translate(`pos.user.ConstentFirstName`)}
                                    icon={<b>?</b>}
                                />
                            }
                        />
                        <Box mt={3}>
                            <CustomTextField
                                required
                                onBlur={() => {
                                    validateFc('lastName', textValue.lastName)
                                }}
                                id="filled-basic"
                                label={translate(`pos.user.lastname`)}
                                value={textValue.lastName}
                                error={validate.lastName.message !== "" && validate.lastName.isError}
                                helperText={validate.lastName.message}
                                onChange={textOnChange('lastName')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleLastName`)}
                                        content={translate(`pos.user.ConstentLastName`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <Box mt={3}>
                            <CustomTextField
                                required
                                onBlur={() => {
                                    validateFc('email', textValue.email)
                                }}
                                id="filled-basic"
                                label={translate(`pos.user.email`)}
                                value={textValue.email}
                                error={validate.email.message !== "" && validate.email.isError}
                                helperText={validate.email.message}
                                onChange={textOnChange('email')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleEmail`)}
                                        content={translate(`pos.user.ConstentEmail`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <Box mt={3}>
                            <CustomTextField
                                className={classes.number}
                                type='number'
                                id="filled-basic"
                                label={translate(`pos.user.phonenumber`)}
                                value={textValue.phoneNumber}
                                onChange={textOnChange('phoneNumber')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitlePhoneNumber`)}
                                        content={translate(`pos.user.ConstentPhoneNumber`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <Box mt={3}>
                            <CustomTextField
                                id="filled-basic"
                                label={translate(`pos.user.company`)}
                                value={textValue.organisation}
                                onChange={textOnChange('organisation')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleCompany`)}
                                        content={translate(`pos.user.ConstentCompany`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <Box pt={1} pb={0} mt={1} >
                            <SelectBox

                                label={translate(`pos.user.role`)}
                                value={<Typography className={classes.TexTSelect} >{role.name}</Typography>}
                                open={openRole}
                                handleClick={handleClickOpenRole}
                            >
                                {
                                    dataRole.map((role, index) => (
                                        <Box hidden={role.name === "Sysadmin" ? true : false} key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeRole(role)}>
                                                <Typography className={classes.TexTSelect} >{role.name}</Typography>
                                            </ListItem>
                                        </Box>
                                    ))
                                }
                            </SelectBox>
                        </Box>
                        <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: ' #e6e6eb' }} />
                        <Card style={{ marginTop: "1em", height: 96, borderRadius: '0' }}  >
                            <CardContent>
                                <Typography className={classes.TitleLevel} gutterBottom>
                                    <Box display='flex' alignItems="center">
                                        {translate(`pos.user.level`)} : {countcluster === "" || countcluster === 0 ? "" :
                                            <Box ml={1} p={0.5} mr={1} width="100px" height="30" className={classes.borderLevel} >
                                                <Box alignItems='center' display='flex'>
                                                    <Typography className={classes.textLevel}>
                                                        {countcluster + " " + translate(countcluster <= 1 ? `pos.user.cluster` : `pos.user.clusters`).toUpperCase()}
                                                    </Typography>
                                                    <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                                                        <CustomPoperUser open={openPoper}

                                                            anchorEl={anchorEl}
                                                            handleClick={handleClickOpenPoper} handleClose={handleClosePoper}
                                                            title={translate(`pos.user.cluster`)}
                                                            content={cluster.join(", ")}
                                                            icon={<b>i</b>} />
                                                    </Box>
                                                </Box>
                                            </Box>}
                                    </Box>
                                </Typography>

                                <Button variant="contained"
                                    style={{ marginTop: '10px' }}
                                    disabled={role === "Sysadmin" ? true : false}
                                    size="small"
                                    color="primary"
                                    onClick={handleOpenDialog}
                                    endIcon={<img alt='' src={edit} style={{ width: "20px", height: 20, marginLeft: "5px" }} />}
                                > <Typography className={classes.textbtnLevel}>{translate(`pos.user.changelevel`)}</Typography></Button>

                            </CardContent>
                            <ChangeLevel
                                open={openDialog}
                                handleCancel={() => {
                                    setOpenDialog(false)
                                    setEntities(cancel)
                                    setExpandAll(false)

                                }}
                                handleSave={() => {
                                    setOpenDialog(false)
                                    handleShowCluster()
                                    setExpandAll(false)

                                }}
                                entities={entities}
                                setEntities={setEntities}
                                expandAll={expandAll}
                                setExpandAll={setExpandAll}
                            >
                            </ChangeLevel>
                        </Card>
                        <Box pt={1} pb={0} mt={1} >
                            <SelectBox
                                label={translate(`pos.user.language`)}
                                value={<Box display='flex' alignItems='center' style={{ marginTop: '-5px' }}>
                                    <img alt='' src={`https://www.countryflags.io/${language.code}/flat/32.png`} />
                                    <Box ml={2}><Typography className={classes.TexTSelect} >{language.name}</Typography></Box>
                                </Box>
                                }
                                open={openLanguage}
                                handleClick={handleClickOpenLanguage}
                            >
                                {
                                    dataLanguage.map((Language, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLanguage(Language)}>
                                                <img alt='' src={`https://www.countryflags.io/${Language.code}/flat/32.png`} />
                                                <Box ml={2}><Typography className={classes.TexTSelect} >{Language.name}</Typography></Box>
                                            </ListItem>
                                        </Box>
                                    ))
                                }
                            </SelectBox>
                        </Box>
                        <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                            <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                                <Grid >
                                    <CardContent>
                                        <Avatar src={baseApiUrl + image} className={classes.large} classes={{
                                            img: classes.avatarIcon
                                        }} />
                                    </CardContent>

                                </Grid>
                                <Grid>
                                    <CardContent>
                                        <Typography className={classes.TitleImage} gutterBottom>
                                            {translate(`pos.user.changeimage`)}
                                        </Typography>
                                        <Box>
                                            <input accept="image/*" className={classes.display} id="contained-button-file" type='file' onChange={handleChooseImage} />
                                            <label htmlFor="contained-button-file">
                                                <Button className={classes.borderImage} component="span">
                                                    <Typography className={classes.textBtnImage} > {translate(`pos.user.uploadphoto`)}</Typography>
                                                </Button>
                                            </label>
                                        </Box>
                                    </CardContent>
                                </Grid>
                            </Grid>
                        </Card>
                        <hr style={{ marginTop: "30px", borderTopColor: ' #e6e6eb' }} />
                        <Box display='flex' justifyContent='flex-end'>
                            <Box mr='auto' display='flex'>
                                <Typography className={classes.textRequiredStar} >{translate(`pos.user.star`)}</Typography>
                                <Typography className={classes.textRequired} >{translate(`pos.user.required`)}</Typography>

                            </Box>
                        </Box>
                        <Box display='flex' justifyContent='flex-end'>
                            <Box display='flex' alignItems='flex-end' mr={3} mt={3}  >
                                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/users" }}/>
                                   
                                <Button variant="contained" color='primary' size='large' onClick={handleSubmitUser}
                                    disabled={textValue.userName && textValue.password && textValue.firstName && textValue.lastName && textValue.email !== '' ? false : true}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={20}
                                            thickness={2}
                                            color='inherit'
                                        />
                                    ) : <Typography className={classes.btnCreate}>  {translate(`pos.user.save`)}</Typography>}
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </Box>

            </Box>
        </Box>
    )

}
export default CreateUser

